import wx from 'weixin-js-sdk'
// 微信分享配置
export const wxShareConfig = ({title, desc, link, imgUrl}, success, fail) => {
  // console.log('wxShare Config')
  wx.ready(() => {
    // “分享给朋友”
    wx.onMenuShareAppMessage({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: success,
      fail: fail
    })
    // “分享到朋友圈”
    wx.onMenuShareTimeline({
      title: title,
      link: link,
      imgUrl: imgUrl,
      success: success,
      fail: fail
    })

    // 分享到QQ
    wx.onMenuShareQQ({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: success,
      fail: fail
    })
    // 分享到腾讯微博
    wx.onMenuShareWeibo({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: success,
      fail: fail
    })
    // 分享到QQ空间
    wx.onMenuShareQZone({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: success,
      fail: fail
    })

    // wx.hideOptionMenu()
    wx.showOptionMenu()
    // 隐藏部分菜单
    wx.hideMenuItems({
      menuList: [
        // 'menuItem: editTag',
        // 'menuItem: delete',
        // 'menuItem:copyUrl',
        // 'menuItem:originPage',
        // 'menuItem:readMode',
        // 'menuItem:openWithQQBrowser',
        // 'menuItem:openWithSafari',
        'menuItem:share:email',
        'menuItem:share:brand'
      ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
    })
  })
}

// 选择图片
export const wxChooseImage = ({count, sizeType, sourceType}, success, fail) => {
  // console.log('wxChooseImage')
  // “拍照或从手机相册中选图接口”
  wx.chooseImage({
    count: count, // 默认9
    sizeType: sizeType, // 可以指定是原图还是压缩图，默认二者都有
    sourceType: sourceType, // 可以指定来源是相册还是相机，默认二者都有
    success: success,
    fail: fail
  })
}

// 预览图片
export const wxPreviewImage = ({current, urls}, success, fail) => {
  // console.log('wxPreviewImage')
  // “预览图片接口”
  wx.previewImage({
    current: current, // 当前显示图片的http链接
    urls: urls, // 需要预览的图片http链接列表
    success: success,
    fail: fail
  })
}

// 上传图片
export const wxUploadImage = ({localId, isShowProgressTips}, success, fail) => {
  // console.log('wxUploadImage')
  // “上传图片接口”
  wx.uploadImage({
    localId: localId, // 需要上传的图片的本地ID，由chooseImage接口获得
    isShowProgressTips: isShowProgressTips, // 默认为1，显示进度提示
    success: success,
    fail: fail
  })
}

// 下载图片
export const wxDownloadImage = ({serverId, isShowProgressTips}, success, fail) => {
  // console.log('wxDownloadImage')
  // “下载图片接口”
  wx.downloadImage({
    serverId: serverId, // 需要下载的图片的服务器端ID，由uploadImage接口获得
    isShowProgressTips: isShowProgressTips, // 默认为1，显示进度提示
    success: success,
    fail: fail
  })
}
